(function () {
  'use strict';

  function init(root) {
    if (!root || root.__casaInit) return;
    root.__casaInit = true;

    var nav = root.querySelector('[data-nav]');
    var navItems = root.querySelectorAll('.nav-item');
    var megas = root.querySelectorAll('.mega');
    var hideTimer;

    function closeAllMega() {
      megas.forEach(function (m) { m.classList.remove('open'); });
      navItems.forEach(function (n) { n.classList.remove('hovered'); });
    }

    navItems.forEach(function (item) {
      var idx = item.getAttribute('data-nav-link');
      var mega = root.querySelector('.mega[data-mega="' + idx + '"]');
      item.addEventListener('mouseenter', function () {
        clearTimeout(hideTimer);
        closeAllMega();
        item.classList.add('hovered');
        if (mega) {
          mega.classList.add('open');
          // staggered delays
          mega.querySelectorAll('.mm-side .cat').forEach(function (c, i) { c.style.animationDelay = (i * 0.006) + 's'; });
          mega.querySelectorAll('.mm-group').forEach(function (g, i) { g.style.animationDelay = (i * 0.01) + 's'; });
          var media = mega.querySelector('.mm-media'); if (media) media.style.animationDelay = '0.01s';
        }
      });
      if (mega) {
        // category switching inside this mega
        var cats = mega.querySelectorAll('.mm-side .cat');
        var colsets = mega.querySelectorAll('.mm-colset');
        cats.forEach(function (c) {
          c.addEventListener('mouseenter', function () {
            var ci = c.getAttribute('data-cat');
            cats.forEach(function (x) { x.classList.remove('active'); });
            c.classList.add('active');
            colsets.forEach(function (cs) {
              cs.classList.toggle('active', cs.getAttribute('data-colset') === ci);
            });
          });
        });
        mega.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
      }
    });

    if (nav) {
      nav.addEventListener('mouseleave', function () {
        hideTimer = setTimeout(closeAllMega, 120);
      });
    }

    // ===== Nav scroll indicator (shows fade when more items exist to the right) =====
    var navInner = root.querySelector('.nav-inner');
    if (nav && navInner) {
      function updateScrollHint() {
        var hasMore = navInner.scrollWidth > navInner.clientWidth + 4 &&
          (navInner.scrollLeft + navInner.clientWidth) < (navInner.scrollWidth - 4);
        nav.classList.toggle('has-scroll', hasMore);
      }
      updateScrollHint();
      navInner.addEventListener('scroll', updateScrollHint);
      window.addEventListener('resize', updateScrollHint);
    }

    // ===== Mobile drawer =====
    var drawer = root.querySelector('[data-drawer]');
    var overlay = root.querySelector('[data-overlay]');
    function openDrawer() { if (drawer) { drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; } }
    function closeDrawer() { if (drawer) { drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow = ''; } }
    var openBtn = root.querySelector('[data-open-drawer]');
    var closeBtn = root.querySelector('[data-close-drawer]');
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // accordion
    root.querySelectorAll('.acc-head').forEach(function (h) {
      h.addEventListener('click', function (e) {
        var item = h.parentElement;
        if (item.querySelector('.acc-body')) { e.preventDefault(); item.classList.toggle('open'); }
      });
    });

    // ===== Search dropdown =====
    var searchBox = root.querySelector('[data-search-box]');
    var searchPanel = root.querySelector('[data-search-panel]');
    var searchInput = root.querySelector('[data-search-input]');
    var mobileSearch = root.querySelector('[data-mobile-search]');
    var searchSubmit = searchBox ? searchBox.querySelector('.search-submit') : null;
    function openSearch() { if (searchPanel) { searchPanel.classList.add('open'); if (searchBox) searchBox.classList.add('focused'); } }
    function closeSearch() { if (searchPanel) { searchPanel.classList.remove('open'); if (searchBox) searchBox.classList.remove('focused'); } }
    if (searchInput) {
      searchInput.addEventListener('focus', openSearch);
      searchInput.addEventListener('click', function (e) { e.stopPropagation(); openSearch(); });
    }
    // submit button should submit the form, not toggle dropdown
    if (searchSubmit) searchSubmit.addEventListener('click', function () { if (searchBox && searchBox.tagName === 'FORM') searchBox.submit(); });
    if (mobileSearch) mobileSearch.addEventListener('click', function (e) {
      e.stopPropagation();
      searchPanel && searchPanel.classList.contains('open') ? closeSearch() : openSearch();
    });
    document.addEventListener('click', function (e) {
      if (searchPanel && (!searchBox || !searchBox.contains(e.target)) && !searchPanel.contains(e.target) && (!mobileSearch || !mobileSearch.contains(e.target))) closeSearch();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSearch(); closeDrawer(); } });

    // ===== Cart: link goes to /cart page (theme drawer not hooked) =====
    // Cart icons are plain links to routes.cart_url — no JS needed.
  }

  function boot() {
    document.querySelectorAll('[data-casa-header]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init in Shopify theme editor
  document.addEventListener('shopify:section:load', boot);
})();
